import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import Loader from '../../ApiCheck/Loader'; 
import { baseUrl } from '../../ApiCheck/Constant';

const Register = () => {
  const navigate = useNavigate();
 
  const [data, setData] = useState({
    email: '',
    password: '',
    firstname: '',
    lastname: '',
    phonenumber: '',
    profilepic: null,
  });
  
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); 
  
  const user = useSelector((state) => state.user);
  useEffect(() => {
    if (user.isAuth) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setData({
        ...data,
        profilepic: reader.result,
      });
    };
    reader.readAsDataURL(file);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.profilepic) {
      setError('Profile picture is required.');
      return;
    }
    setLoading(true);

    try {
      const response = await axios.post(`${baseUrl}/api/signup`, data);
      toast.success('Registration Successful', { position: 'top-center', autoClose: 3000 });
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.message, { position: 'top-center', autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center">
      <div className="wrapper w-50 bg-white mt-2 text-dark rounded shadow-lg p-4">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="title h2 text-center mb-2">Register Form</div>
            <form className="register-data" method="POST" onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="firstname" className="form-label">First Name</label>
                <input
                  type="text"
                  id="firstname"
                  name="firstname"
                  value={data.firstname}
                  onChange={handleOnChange}
                  required
                  className="form-control border-dark"
                  placeholder="Enter your first name"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="lastname" className="form-label">Last Name</label>
                <input
                  type="text"
                  id="lastname"
                  name="lastname"
                  value={data.lastname}
                  onChange={handleOnChange}
                  required
                  className="form-control border-dark"
                  placeholder="Enter your last name"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={data.email}
                  onChange={handleOnChange}
                  required
                  className="form-control border-dark"
                  placeholder="Enter your email"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="phonenumber" className="form-label">Phone Number</label>
                <input
                  type="tel"
                  id="phonenumber"
                  name="phonenumber"
                  value={data.phonenumber}
                  onChange={handleOnChange}
                  maxLength={10}
                  minLength={10}
                  pattern="[0-9+]*"
                  required
                  className="form-control border-dark"
                  placeholder="Enter your phone number"
                />
              </div>
              <div className="mb-3 position-relative">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={data.password}
                  onChange={handleOnChange}
                  required
                  className="form-control border-dark"
                  placeholder="Enter your password"
                />
                <span 
                  className="position-absolute top-50 end-0 translate-middle-y m-3" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                </span>
              </div>
              <div className="mb-3">
                <label htmlFor="profilepic" className="form-label">Profile Picture</label>
                <input
                  type="file"
                  id="profilepic"
                  onChange={handleImageChange}
                  accept="image/*"
                  className="form-control border-dark"
                />
                {error && <p className="text-danger mt-2">{error}</p>}
              </div>
              <div className="mb-3">
                <input type="submit" value="Register" className="btn btn-dark w-100" />
              </div>
              <div className="signup-link text-center">
                Already have an account? <Link to="/login" className="text-dark">Login</Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default Register;
